import { render, staticRenderFns } from "./CategoryDrugs.vue?vue&type=template&id=75b6c27e&scoped=true"
import script from "./CategoryDrugs.vue?vue&type=script&lang=js"
export * from "./CategoryDrugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b6c27e",
  null
  
)

export default component.exports